import musicLib from "../../assets/musicLib.png";
import YouTube from "../../assets/youtube-organizer.png";
import Wordle from "../../assets/wordle.png";
import Game from "../../assets/2dworld.png";

export const projectsData = [
  {
    id: 1,
    image: musicLib,
    title: "Music Lib",
    category: "web",
    description:
      "A music library for you to listen and store your favorite music.",
    url: "https://github.com/andrewhsugithub/Music-Lib",
  },
  {
    id: 2,
    image: YouTube,
    title: "YouTube Organizer",
    category: "app",
    description:
      "An app that helps you organize your personal YouTube channel.",
    url: "https://github.com/andrewhsugithub/YouTube-Organizer",
  },
  {
    id: 3,
    image: Wordle,
    title: "Guess a Word",
    category: "app",
    description: "A Wordle Clone with more fun and challenges waiting for you!",
    url: "https://github.com/andrewhsugithub/Guess-a-Word",
  },
  {
    id: 4,
    image: Game,
    title: "2d Open World Game",
    category: "app",
    description: "A 2d open world game for you to explore!!!",
    url: "https://github.com/andrewhsugithub/2d-Open-World-Game",
  },
];

export const projectsNav = [
  {
    name: "all",
  },
  {
    name: "web",
  },
  {
    name: "app",
  },
];
